const curRouter = {
	state:{
		subList:new Object,
		subChildrenList:new Object,
	},
	mutations:{
		SET_SUBROUTER:(state, subList) => {
			state.subList = subList;
		},
		SET_SUBCHILDRENROUTER:(state, subChildrenList) => {
			state.subChildrenList = subChildrenList;
		}
	},
	actions:{
		getSubRouter({commit},subRouter){
			commit('SET_SUBROUTER',subRouter)
		},
		getSubChildrenRouter({commit},subChildrenRouter){
			commit('SET_SUBCHILDRENROUTER',subChildrenRouter)
		},
	}
}
export default curRouter;



// WEBPACK FOOTER //
// ./src/store/modules/curRouter.js